import { render, staticRenderFns } from "./Plots.vue?vue&type=template&id=f7868cd6&scoped=true&"
import script from "./Plots.vue?vue&type=script&lang=js&"
export * from "./Plots.vue?vue&type=script&lang=js&"
import style0 from "./Plots.vue?vue&type=style&index=0&id=f7868cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7868cd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VIcon,VOverlay,VProgressCircular})
